import { takeEvery, all, call, put, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { SweetAlertResult } from 'sweetalert2';
import apiService from 'app/bff/services/apiService';
import { AuthStatusIdEnum } from 'app/bff/enums/auth';
import { LoginTypesEnum } from 'app/bff/enums/login';
import { AaSigninResp } from 'app/bff/models/aa/aaSignin';
import { MbUpdateinfoResp } from 'app/bff/models/mb/mbUpdateinfo';
import { ROUTES } from 'app/core/router/paths';
import modalService from 'app/core/services/modalService';
import { ProcessRouteMatchesStep } from 'app/features/Member/Settings/PassPhrase/types';
import { RootState } from 'app/store/types';
import { sagaBoundary } from 'app/store/service';
import { CommonState } from 'app/store/common/types';
import { sendLogoutAction } from 'app/store/features/member/login/actions';
import { MEMBER_SETTINGS_PASS_PHRASE__AUTH_PASS_PHRASE, MEMBER_SETTINGS_PASS_PHRASE__SETUP_PASS_PHRASE, AuthPassPhraseAction, SetupPassPhraseAction } from './types';
import { setAccessibleStepAction } from './actions';

/**
 * @description 驗證會員密碼
 */
function * authPassPhrase (action: AuthPassPhraseAction) {
  const response: AaSigninResp = yield call(apiService.postAaSignin, action.payload.args);
  if (response && response.userResult === AuthStatusIdEnum.Success) {
    // 將「輸入新密碼」(Step-2) 設為可訪問步驟
    yield put(setAccessibleStepAction(ProcessRouteMatchesStep[ROUTES.MEMBER__SETTINGS__PASS_PHRASE__SETUP]));
    // 導頁至「輸入新密碼」(Step-2)
    yield put(push(ROUTES.MEMBER__SETTINGS__PASS_PHRASE__SETUP));
  } else if (response && !response.userResult) {
    // 登入失敗提醒跳窗
    modalService.base('系統提醒', '帳號已被鎖定, 請洽客服。');
    // 關閉「會員登入」Modal
    modalService.login(false);
  }
  // else {
  //   modalService.base('系統提醒', '您輸入的密碼有誤，請重新輸入');
  // }
}

/**
 * @description 設置會員密碼
 */
function * setupPassPhrase (action: SetupPassPhraseAction) {
  const response: MbUpdateinfoResp = yield call(apiService.postMbUpdateinfo, action.payload.args);
  const memberProfileState: CommonState['member']['profile'] = yield select((state: RootState) => state.common.member.profile);
  if (response && memberProfileState) {
    const result: SweetAlertResult = yield modalService.confirm('變更完成', '您的密碼已重設，請用新密碼登入', '立即登入', '回首頁');
    // 立即登入 (開啟登入跳窗)
    if (result.value && result.isConfirmed) modalService.login(true);
    // 執行會員登出
    const { USER_ID, userName } = memberProfileState.USERS;
    yield put(sendLogoutAction({ loginType: LoginTypesEnum.FrontendLogout, USER_ID, userName }));
    // 導頁至主首頁
    yield put(push(ROUTES.HOME__MAIN));
  }
}

export default function * watchPassPhraseSaga () {
  yield all([
    takeEvery(MEMBER_SETTINGS_PASS_PHRASE__AUTH_PASS_PHRASE, sagaBoundary(authPassPhrase)),
    takeEvery(MEMBER_SETTINGS_PASS_PHRASE__SETUP_PASS_PHRASE, sagaBoundary(setupPassPhrase))
  ]);
}
